export const global_breakpoint_sm = {
  "name": "--pf-global--breakpoint--sm",
  "value": "576px",
  "var": "var(--pf-global--breakpoint--sm)"
};
export default global_breakpoint_sm;